export enum ProjectType {
    SAP = 1,
    UPGRADE = 2,
    CLEANSING = 5,
    SUPPORT_PACKAGE = 6,
    TESTING_ONLY = 9,
    ENHANCEMENT_PACKAGE = 12,
    ORACLE_PATCHES = 13,
    JDE = 15,
    ORACLE_UPGRADE = 101,
    ORACLE_ONLINE_PATCHES = 14,
    STANDALONE_PROJECT = 19,
    S4_DISCOVERY_PACK = 20,
    S4_CONVERT = 21,
    S4_ACCELERATE = 22,
    ICR_3 = 23,
    S4_GREEN = 24,
    S4_CONVERT_NEW = 25,
    S4_ACCELERATE_NEW = 26,
    CLEAN_CORE = 27,
    SUPPORT_PACKAGE_NEW = 28
}

export enum ProjectSubType {
    ORACLE_UPGRADE = 13,
    END2END_SUBTYPE = 16,
    VF_SECURITY = 19,
    IMPACT_ANALYSIS = 20,
    ONGOING_CHANGES = 21,
    S4_PREP = 22,
    S4_GREEN_BASIC = 23,
    ICR_3_S4_CONVERSION = 24,
    ICR_3_S4_ACCELERATE = 25
}

export function isUnifiedProjectType(projectType: number): boolean {
    return (
        projectType === ProjectType.S4_CONVERT_NEW ||
        projectType === ProjectType.S4_ACCELERATE_NEW ||
        projectType === ProjectType.SUPPORT_PACKAGE_NEW
    );
}
